import { useEffect, useState } from 'react';
import { useCountDown } from 'ahooks';

interface UseCountdownProps {
    isCounting?: boolean;
    /** 单位 s */
    time?: number;
    onEnd?: () => void;
}

export const useCountdown = (props?: UseCountdownProps) => {
    const { isCounting = false, time = 60, onEnd } = props || {};

    const [targetDate, setTargetDate] = useState<number>();

    const [countdown] = useCountDown({
        targetDate,
        onEnd: () => {
            onEnd?.();
        },
    });

    useEffect(() => {
        if (isCounting) {
            setTargetDate(Date.now() + time * 1000);
        }
    }, [isCounting, time]);

    return {
        countdown: Math.round(countdown / 1000),
    };
};
